export default {
  settings: {
    logo: {
      heading: null,
      subheading: null,
      video_url: null,
      image_url:
        'https://firebasestorage.googleapis.com/v0/b/sustento-juridico.appspot.com/o/Logo%2FLOGO%20BLANCO%20DESDE%202013_Mesa%20de%20trabajo%201.png?alt=media&token=f489f5ae-2258-41f6-baef-52c312917340',
    },
    header: {
      heading: 'Sustento Jurídico',
      subheading: 'Asesoría legal integral con más de una década de experiencia',
      video_url: null,
      image_url: null,
    },
    about: {
      heading: 'Quiénes somos',
      subheading:
        'Somos un equipo de abogados comprometidos con brindar soluciones jurídicas efectivas, transparentes y cercanas a nuestros clientes.',
      video_url: null,
      image_url: null,
    },
  },
  services: [
    {
      id: 1,
      icon: 'fa-balance-scale',
      heading: 'Derecho laboral',
      description: 'Asesoría y representación en conflictos laborales, despidos, liquidaciones y seguridad social.',
      sort_order: 1,
    },
    {
      id: 2,
      icon: 'fa-building',
      heading: 'Derecho comercial',
      description: 'Constitución de empresas, contratos comerciales, cobro prejudicial y recuperación de cartera.',
      sort_order: 2,
    },
    {
      id: 3,
      icon: 'fa-gavel',
      heading: 'Derecho civil',
      description: 'Sucesiones, responsabilidad civil, contratos y conflictos entre particulares.',
      sort_order: 3,
    },
    {
      id: 4,
      icon: 'fa-handshake-o',
      heading: 'Conciliación',
      description: 'Acompañamiento en procesos de conciliación extrajudicial y judicial.',
      sort_order: 4,
    },
  ],
  team: [
    {
      id: 1,
      name: 'María González',
      role: 'Directora jurídica',
      bio: 'Especialista en derecho laboral con más de 15 años de experiencia.',
      image_url: '/assets/images/team-1.jpg',
      sort_order: 1,
    },
    {
      id: 2,
      name: 'Carlos Ruiz',
      role: 'Abogado senior',
      bio: 'Experto en derecho comercial y contratos empresariales.',
      image_url: '/assets/images/team-2.jpg',
      sort_order: 2,
    },
    {
      id: 3,
      name: 'Ana Martínez',
      role: 'Abogada litigante',
      bio: 'Amplia trayectoria en procesos civiles y conciliación.',
      image_url: '/assets/images/team-3.jpg',
      sort_order: 3,
    },
    {
      id: 4,
      name: 'Luis Herrera',
      role: 'Asesor legal',
      bio: 'Enfoque en prevención del riesgo legal para empresas.',
      image_url: '/assets/images/team-4.jpg',
      sort_order: 4,
    },
  ],
  clients: [
    { id: 1, name: 'Cliente 1', logo_url: '/assets/images/client-logo-1.png', sort_order: 1 },
    { id: 2, name: 'Cliente 2', logo_url: '/assets/images/client-logo-2.png', sort_order: 2 },
    { id: 3, name: 'Cliente 3', logo_url: '/assets/images/client-logo-3.png', sort_order: 3 },
    { id: 4, name: 'Cliente 4', logo_url: '/assets/images/client-logo-4.png', sort_order: 4 },
    { id: 5, name: 'Cliente 5', logo_url: '/assets/images/client-logo-5.png', sort_order: 5 },
  ],
  blog: [
    {
      id: 1,
      title: 'Novedades en derecho laboral 2024',
      excerpt: 'Conoce los cambios más relevantes que afectan a empleadores y trabajadores.',
      content: 'El marco normativo laboral ha experimentado importantes actualizaciones este año.',
      author: 'Sustento Jurídico',
      image_url: '/assets/images/post-1.jpg',
      published_at: '2024-03-15',
    },
    {
      id: 2,
      title: '¿Cuándo conviene conciliar?',
      excerpt: 'La conciliación puede ser una vía eficiente para resolver conflictos.',
      content: 'Antes de iniciar un proceso judicial, evaluar la conciliación puede ahorrar tiempo y recursos.',
      author: 'Sustento Jurídico',
      image_url: '/assets/images/post-2.jpg',
      published_at: '2024-02-20',
    },
    {
      id: 3,
      title: 'Protección de datos en empresas',
      excerpt: 'Obligaciones básicas que toda organización debe conocer.',
      content: 'El tratamiento de datos personales exige políticas claras y medidas de seguridad.',
      author: 'Sustento Jurídico',
      image_url: '/assets/images/post-3.jpg',
      published_at: '2024-01-10',
    },
  ],
};
